import React from 'react';
import { IClientInfo } from '../../lib/types';
import { resolveAssetUrl } from '../../lib/ultra-meet-config';
import styles from '../../styles/AppBranding.module.css';
import { PartnerLogo } from './PartnerLogo';

interface AppBrandingProps {
  themeConfig: IClientInfo;
  translations: any;
  height?: number;
}

export const AppBranding: React.FC<AppBrandingProps> = ({
  themeConfig,
  translations,
  height
}) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.logoRow}
        style={height ? ({ '--branding-logo-height': `${height}px` } as React.CSSProperties) : undefined}
      >
        <PartnerLogo className={styles.partnerLogo} />
        <img src={resolveAssetUrl(themeConfig.logo)} className={styles.logo} alt={themeConfig.title} />
      </div>
      <p className={styles.slogan}>{translations.slogan || themeConfig.slogan}</p>
    </div>
  );
};
